import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=38f74553&"
import script from "./ProfileDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports